// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__320pW","first-footer-row":"Footer_first-footer-row__1MBaE","second-footer-row":"Footer_second-footer-row__12Qvo"};